import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Params } from '@angular/router';
import { currencyFormatter } from '@cigna/chcp/claims/shared/util';
// TODO: https://git.sys.cigna.com/angular-guild/cigna-nx/issues/567
// TODO: resolve CHCP disables by bot
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FlaggedClaim } from '@cigna/chcp/shared/user-profile-data-access';
import { mapInboundClaimStatus } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-claim-detail-item',
  templateUrl: './claim-detail-item.component.html',
  styleUrls: ['./claim-detail-item.component.scss', '../dashboard-tile.scss'],
})
export class ClaimDetailItemComponent {
  @Input() isEditable = true;
  @Input() flaggedKeys: string[] = [];
  @Input() isFlagView = false;
  @Input() isRestrictedImpersonator = false;

  @Output() flag = new EventEmitter();
  @Input() set claim(value: FlaggedClaim) {
    this._claim = value;
    const { tinNumbers, claimSummary } = value;
    if (claimSummary.claimCompositeKey.includes('invalid_identifier')) {
      this.routeDetails = {
        url: '/claim/multiplepatients/',
        state: this._claim,
      };
    } else {
      this.routeDetails = {
        url: `/claim/detail/${claimSummary.claimReferenceNumber}`,
        queryParams: {
          tin: tinNumbers.join(),
          claimCompositeKey: claimSummary.claimCompositeKey,
          compositeClaimId: claimSummary.compositeClaimId,
          medicare: claimSummary.medicare,
          memberSearch: 'Y',
        },
      };
    }
  }
  get claim() {
    return this._claim;
  }

  _claim: FlaggedClaim;
  routeDetails: { url: string; queryParams?: Params; state?: Params };

  mapInboundClaimStatus = mapInboundClaimStatus;
  currencyFormatter = currencyFormatter;

  flagClick(checked: boolean, claim: FlaggedClaim) {
    this.flag.emit({ checked, claims: [claim] });
  }
}
